// extracted by mini-css-extract-plugin
module.exports = {"table":"StockTransferTable_table__2Tk2d","pink":"StockTransferTable_pink__3_52f","green":"StockTransferTable_green__lpE6A","noCenter":"StockTransferTable_noCenter__3l7f0"};